import { render } from "./RuiIcon.vue?vue&type=template&id=77f156ca&scoped=true"
import script from "./RuiIcon.vue?vue&type=script&lang=js"
export * from "./RuiIcon.vue?vue&type=script&lang=js"

import "./RuiIcon.vue?vue&type=style&index=0&id=77f156ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-77f156ca"

export default script